<template>
  <el-dialog class="dialog1" :visible.sync="showLogin" width="900px" :show-close="false" :close-on-click-modal="false">
    <div>
      <!-- 验证码登录 -->
      <div class="login-wrap" v-if="loginType === 2">
        <div class="header">
          <!-- <img src="./close@2x.png" @click="closeDialog" class="close" alt="" />  -->
          <img class="header-logo" v-show="language == 'zh-CN'" />
          <img src="@/assets/img/logo/logo-india5.png" class="header-logo" v-show="language == 'en-US'" />
          <div class="contenRight">
            <div class="contenHeader">
              <img src="./img/header1.png" alt="" style="height: 100px; width: 100px; float: left; margin-left: 108px; cursor: pointer" />
              <img src="./img/header2.png" @click="toLoginPassword" alt="" style="cursor: pointer; height: 100px; width: 100px; float: left; margin-left: 135px" />
              <img src="./img/header3.png" @click="closeDialog" class="close" alt="" />
            </div>
            <div class="content1">
              <div class="content">
                <div class="input1">
                  <div class="a">{{ $t("login.country") }}</div>
                  <div class="b"></div>
                  <el-input style="flex: 1" :placeholder="$t('login.please-enter-phone-number')" v-model.trim="formCode.phone" @input="formatPhone"></el-input>
                  <img style="cursor: pointer" @click="formCode.phone = ''" v-show="formCode.phone.length > 0" src="./img/delete.png" alt="" />
                </div>
                <div class="input1">
                  <img class="sms-code" alt="" />
                  <el-input :placeholder="$t('login.please-enter-verification-code')" maxlength="4" type="tel" v-model.trim="formCode.code" @input="formatVerifyCode">
                    <div slot="suffix" :class="[!isSend ? 'send_class' : 'last_down_time']" @click.stop="beforeSendCode">
                      {{ sendText }}
                    </div>
                  </el-input>
                </div>
                <div v-show="!textErr.length" class="message">
                  <img src="./img/notice.png" alt="" />
                  <div>{{ $t("login.unregistered-phone-auto-create") }}</div>
                </div>
                <div v-show="textErr.length" class="message">
                  <img src="./img/notice-error.png" alt="" />
                  <div style="color: #db6372">{{ textErr }}</div>
                </div>
                <el-button class="btn-confirm" :class="{ active: isConfirm }" :disabled="!isConfirm" @click="beforeLoginOfPwd" :loading="loading">{{ $t("login.login") }}</el-button>
                <!-- <div class="pass-login" @click="toLoginPassword">{{ $t("login.password-login") }}</div> -->
                <div class="pass-login">&nbsp;</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 密码登录 -->
      <div class="login-wrap" v-if="loginType === 1">
        <div class="activeHeader header">
          <!-- <img src="./close@2x.png" @click="closeDialog" class="close" alt="" /> -->
          <img class="header-logo" v-show="language == 'zh-CN'" />
          <img src="@/assets/img/logo/logo-india5.png" class="header-logo" v-show="language == 'en-US'" />
          <div class="contenRight">
            <div class="contenHeader">
              <img src="./img/header4.png" @click="toLoginCode" alt="" style="height: 100px; width: 100px; float: left; margin-left: 108px; cursor: pointer" />
              <img src="./img/header5.png" alt="" style="cursor: pointer; height: 100px; width: 100px; float: left; margin-left: 135px" />
              <img src="./img/header3.png" @click="closeDialog" class="close" alt="" />
            </div>
            <div class="content1">
              <div class="content">
                <div class="input1">
                  <div class="a">{{ $t("login.country") }}</div>
                  <div class="b"></div>
                  <el-input style="flex: 1" :placeholder="$t('login.please-enter-phone-number')" v-model.trim="formCode.phone" @input="formatPhone"> </el-input>
                  <img style="cursor: pointer" @click="formCode.phone = ''" v-show="formCode.phone.length" src="./img/delete.png" alt="" />
                </div>
                <div class="input1">
                  <img class="sms-code" alt="" />
                  <el-input :placeholder="$t('login.please-enter-password')" :type="passwordInputType ? 'password' : 'text'" v-model.trim="formCode.passwd"> </el-input>
                  <img class="password" @click="formCode.passwd = ''" v-show="formCode.passwd.length > 0" src="./img/delete.png" alt="" />
                  <img class="password" @click="passwordInputType = !passwordInputType" :src="passwordInputType ? close_eyes : open_eyes" alt="" />
                </div>
                <div v-show="!textErr.length" class="message">
                  <img src="./img/notice.png" alt="" />
                  <div>{{ $t("login.unregistered-phone-auto-create") }}</div>
                  <div style="flex: 1"></div>
                  <!-- <div @click="toForgetPassword" class="forget">{{ $t("login.forget-the-password") }}</div> -->
                </div>
                <div v-show="textErr.length" class="message">
                  <img src="./img/notice-error.png" alt="" />
                  <div style="color: #db6372; flex: 1">{{ textErr }}</div>
                  <!-- <div @click="toForgetPassword" class="forget">{{ $t("login.forget-the-password") }}</div> -->
                </div>
                <el-button class="btn-confirm" :class="{ active: isConfirm }" :disabled="!isConfirm" :loading="loading" @click="beforeLoginOfPwd">{{ $t("login.login") }}</el-button>
                <div class="pass-login" @click="toForgetPassword">{{ $t("login.forget-the-password") }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 忘记密码 第一步-->
      <div class="login-wrap" v-if="loginType === 3" style="margin-left: 180px">
        <div class="header header-forget">
          <img src="./close@2x.png" @click="closeDialog" class="close" alt="" />
          <div class="text">
            <img src="./img/password-header.png" style="width: 100px; height: 100px; margin-bottom: 10px" alt="" />
            {{ $t("login.forget-the-password1") }}
          </div>
          <div class="step">
            <img v-if="step > 0" src="./img/step1-act.png" alt="">
            <img v-else src="./img/step1.png" alt="">
            <!-- <div :class="['round', step > 0 ? 'round-active' : '']">1</div> -->
            <div :class="['bar', step > 1 ? 'bar-active' : '']"></div>
            <img v-if="step > 1" src="./img/step2-act.png" alt="">
            <img v-else src="./img/step2.png" alt="">
            <!-- <div :class="['round', step > 1 ? 'round-active' : '']">2</div> -->
            <div :class="['bar', step > 2 ? 'bar-active' : '']"></div>
            <img v-if="step > 2" src="./img/step3-act.png" alt="">
            <img v-else src="./img/step3.png" alt="">
            <!-- <div :class="['round', step > 2 ? 'round-active' : '']">3</div> -->
          </div>
          <div class="desc">
            <div :style="{ color: step > 0 ? 'var(--theme-primary)' : '#212121' }">{{ $t("login.phone-verification") }}</div>
            <div :style="{ color: step > 1 ? 'var(--theme-primary)' : '#212121' }">{{ $t("login.set-new-password") }}</div>
            <div :style="{ color: step > 2 ? 'var(--theme-primary)' : '#212121' }">{{ $t("login.setup-successful") }}</div>
          </div>

          <div class="content-pss" v-if="step === 1">
            <div class="content-pss1">
              <div class="input1">
                <div class="a">{{ $t("login.country") }}</div>
                <div class="b"></div>
                <el-input class="input__inner" style="flex: 1; background: #f1f3f6" :placeholder="$t('login.please-enter-phone-number')" v-model.trim="formCode.phone" @input="formatPhone"></el-input>
                <img @click="formCode.phone = ''" v-show="formCode.phone.length" src="./img/delete.png" alt="" />
              </div>
              <div class="input1">
                <img class="sms-code" src="./img/sms-code.png" alt="" />
                <el-input :placeholder="$t('login.please-enter-verification-code')" style="width: 384px" maxlength="4" v-model.trim="formCode.code" @input="formatVerifyCode">
                  <div slot="suffix" :class="[!isSend ? 'send_class' : 'last_down_time']" @click="beforeSendCode">
                    {{ sendText }}
                  </div>
                </el-input>
              </div>
              <div v-show="textErr.length" class="message">
                <img src="./img/notice-error.png" alt="" />
                <div style="color: #db6372">{{ textErr }}</div>
              </div>
              <div class="btn-confirm" :class="{ active: isConfirm }" @click="toForgetPasswordStep2()">{{ $t("login.change-password") }}</div>
              <div class="pass-login" @click="toLoginCode">{{ $t("login.back-login") }}</div>
            </div>
          </div>
          <div class="content-pss" v-if="step === 2">
            <div class="content-pss1">
              <!-- <div class="notice">{{ $t("login.your-password-must-contain-6-to-12-letters-and-numbers") }}</div> -->
              <div class="input1">
                <img class="sms-code" src="./img/password.png" alt="" />
                <el-input :placeholder="$t('login.please-enter-password')" :type="passwordInputType1 ? 'password' : 'text'" v-model.trim="formCode.passwd1"> </el-input>
                <img class="password" @click="formCode.passwd1 = ''" v-show="formCode.passwd1.length" src="./img/delete.png" alt="" />
                <img class="password" @click="passwordInputType1 = !passwordInputType1" :src="passwordInputType1 ? close_eyes : open_eyes" alt="" />
              </div>
              <div class="input1">
                <img class="sms-code" src="./img/password.png" alt="" />
                <el-input :placeholder="$t('login.please-confirm-password')" :type="passwordInputType2 ? 'password' : 'text'" v-model.trim="formCode.passwd2"> </el-input>
                <img class="password" @click="formCode.passwd2 = ''" v-show="formCode.passwd2.length" src="./img/delete.png" alt="" />
                <img class="password" @click="passwordInputType2 = !passwordInputType2" :src="passwordInputType2 ? close_eyes : open_eyes" alt="" />
              </div>
              <div v-show="textErr.length == 0" class="message">
                <img src="./img/notice.png" alt="" />
                <div style="color: #734f07">{{ $t("login.your-password-must-contain-6-to-12-letters-and-numbers") }}</div>
              </div>
              <div v-show="textErr.length" class="message">
                <img src="./img/notice-error.png" alt="" />
                <div style="color: #db6372">{{ textErr }}</div>
              </div>
              <el-button class="btn-confirm" :class="{ active: isConfirmForgetPassword }" @click="changePassword">{{ $t("login.confirm") }}</el-button>
              <div class="pass-login" @click="toForgetPasswordStep1">{{ $t("login.return-to-previous-step") }}</div>
            </div>
          </div>

          <div class="content-pss" v-if="step === 3">
            <div class="content-pss1">
              <!-- <div class="notice">{{ $t("login.your-password-must-contain-6-to-12-letters-and-numbers") }}</div> -->
              <div class="input1">
                <img class="sms-code" src="./img/password.png" alt="" />
                <el-input :placeholder="$t('login.please-enter-password')" :type="passwordInputType1 ? 'password' : 'text'" v-model.trim="formCode.passwd1"> </el-input>
                <img class="password" @click="formCode.passwd1 = ''" v-show="formCode.passwd1.length" src="./img/delete.png" alt="" />
                <img class="password" @click="passwordInputType1 = !passwordInputType1" :src="passwordInputType1 ? close_eyes : open_eyes" alt="" />
              </div>
              <div class="input1">
                <img class="sms-code" src="./img/password.png" alt="" />
                <el-input :placeholder="$t('login.please-confirm-password')" :type="passwordInputType2 ? 'password' : 'text'" v-model.trim="formCode.passwd2"> </el-input>
                <img class="password" @click="formCode.passwd2 = ''" v-show="formCode.passwd2.length" src="./img/delete.png" alt="" />
                <img class="password" @click="passwordInputType2 = !passwordInputType2" :src="passwordInputType2 ? close_eyes : open_eyes" alt="" />
              </div>
              <!-- <div v-show="textErr.length==0" class="message">
            <img src="./img/notice.png" alt="" />
            <div style="color: #734f07">{{ $t("login.your-password-must-contain-6-to-12-letters-and-numbers") }}</div>
          </div> -->
              <div v-show="textErr.length" class="message">
                <img src="./img/notice.png" alt="" />
                <div style="color: #734f07">{{ textErr }}</div>
              </div>
              <!-- <el-button class="btn-confirm" :class="{ active: isConfirmForgetPassword }" @click="changePassword">{{
            $t("login.confirm") }}</el-button> -->
              <div class="pass-login" style="margin-top: 25px" @click="toForgetPasswordStep2">{{ $t("login.return-to-previous-step") }}</div>
            </div>
          </div>
        </div>
      </div>

      <SlideVerify
        v-if="showSlideVerify && loginType === 3"
        class="slide-verify-pos slide-verify-pos-right"
        :h="202"
        :w="480"
        :sw="50"
        :sh="59"
        @success="verifySuccess"
        @close="showSlideVerify = false"
      />
      <SlideVerify v-else-if="showSlideVerify" class="slide-verify-pos" :h="202" :w="480" :sw="50" :sh="59" @success="verifySuccess" @close="showSlideVerify = false" />
    </div>
  </el-dialog>
</template>

<script>
import { post } from "@/util/http";
import { getChannel } from "@/util/channel";
import { mapState, mapMutations, mapActions } from "vuex";
import SlideVerify from "@/components/slide-verify";
import { clearTimUserSigCache } from "@/util/tim";

export default {
  name: "login",
  components: {
    SlideVerify,
  },
  data() {
    return {
      formCode: {
        phone: "",
        code: "",
        passwd: "",
        passwd1: "",
        passwd2: "",
      },
      loginType: 2, // 1 密码登录 2 验证码登录 3忘记密码
      codeTime: 60,
      mobile: "",
      code: "",
      username: "",
      headerBack: false,
      password: "",
      nation_code: 86,
      countryCode: "",
      isSend: false,
      sendText: this.$t("login.send-sms"),
      timeId: null,
      textErr: "",
      isPsdText: true,
      mobile_hash: "",
      phone: "",
      isConfirm: false,
      isConfirmForgetPassword: false,
      step: 1,
      sendCodeType: 0,
      passwordInputType: true, // true password false text
      passwordInputType1: true,
      passwordInputType2: true,
      showSlideVerify: false,
      loading: false,
      language: localStorage.getItem("language"),
    };
  },
  watch: {
    formCode: {
      handler(curVal, oldVal) {
        if (!curVal.phone) {
          this.textErr = "";
        }
        this.isConfirm = !!((curVal.phone && curVal.code) || (curVal.phone && curVal.passwd));
        this.isConfirmForgetPassword = !!(curVal.passwd1 && curVal.passwd2);
      },
      deep: true, // 这里深度监听变化，直接触发下面方法
      immediate: true, // 是否第一次触发
    },
  },
  mounted() {},
  computed: {
    ...mapState(["showLogin", "appConfig"]),
    countText() {
      if (this.codeTime < 60 && this.codeTime > 0) return `${this.codeTime}s`;
      return "获取验证码";
    },
  },

  methods: {
    ...mapMutations(["changeLoginType", "changeUserInfo", "toggleLogin", "clearChatList"]),
    ...mapActions(["getUserInfo"]),

    verifySuccess(verifyInfo) {
      this.showSlideVerify = false;
      console.log("验证成功", this.loginType, verifyInfo);

      if (this.loginType === 1) {
        this.loginSubmit();
      } else {
        this.sendCode();
      }
    },

    closeDialog() {
      this.toggleLogin();
      this.showSlideVerify = false;
      this.loginType = 2;
      this.passwordInputType = true;
      this.passwordInputType1 = true;
      this.passwordInputType2 = true;
      this.formCode = {
        phone: "",
        code: "",
        passwd: "",
        passwd1: "",
        passwd2: "",
      };
      this.sendText = this.$t("login.send-sms");
    },

    toLoginPassword() {
      this.headerBack = true;
      this.loginType = 1;
      this.passwordInputType = true;
      this.passwordInputType1 = true;
      this.passwordInputType2 = true;
      this.formCode.code = "";
      this.showSlideVerify = false;
    },

    toLoginCode() {
      this.headerBack = false;
      this.loginType = 2;
      this.formCode.passwd = "";
    },

    toForgetPassword() {
      this.formCode.passwd = "";
      this.sendCodeType = 1;
      this.step = 1;
      this.loginType = 3;
    },

    toForgetPasswordStep1() {
      this.formCode.passwd = "";
      this.formCode.passwd1 = "";
      this.formCode.passwd2 = "";
      this.sendCodeType = 1;
      this.step = 1;
    },
    toForgetPasswordStep2() {
      this.step = 2;
    },
    /**
     * 清理并格式化用户输入的手机号
     * @param {string} num 用户输入的手机号
     */
    formatPhone(num) {
      // num = num.replace(/\s+/g, "");
      num = num.replace(/\D+/g, "");
      if (num.length > 3 && num.length < 8) {
        num = num.replace(/^(\d{3})/g, "$1 ");
      }
      if (num.length >= 8) {
        num = num.replace(/^(\d{3})(\d{4})/g, "$1 $2 ");
      }
      if (num.length >= 13) {
        num = num.slice(0, 13);
      }
      this.formCode.phone = num;
    },

    /**
     * 清理并格式化用户输入的短信验证码
     * @param {string} code 短信验证码
     */
    formatVerifyCode(code) {
      code = code.replace(/\D+/g, "");
      if (code.length > 6) {
        code = code.slice(0, 6);
      }
      this.formCode.code = code;
    },

    // 返送验证码之前
    beforeSendCode() {
      if (this.isSend) return;
      const phone = this.formCode.phone.replace(/\s+/g, "");
      if (!phone) {
        this.textErr = this.$t("login.phone-number-does-not-have-value");
        return;
      }
      if (phone.length !== 11 && LOCALE == "zh-CN") {
        this.textErr = this.$t("login.please-enter-a-valid-phone-number");
        return;
      }
      if (!/^1[3456789]\d{9}$/.test(phone) && LOCALE == "zh-CN") {
        this.textErr = this.$t("login.please-enter-a-valid-phone-number");
        return;
      }
      this.textErr = "";
      this.showSlideVerify = true;
    },

    // 发送验证码
    sendCode() {
      const phone = this.formCode.phone.replace(/\s+/g, "");

      post({
        url: "/api/user/sendCode",
        data: { mobile: phone, is_change_mobile: this.sendCodeType },
      })
        .then(({ data: { data, status, msg } }) => {
          if (status === 0) {
            if (this.sendCodeType === 0) {
              this.$message.success(this.$t("login.sent-successfully"));
            }
            this.isSend = true;
            let time = 60;
            this.sendText = time + "s";
            this.timeId = setInterval(() => {
              time--;
              this.sendText = time + "s";
              if (time <= 0) {
                this.sendText = this.$t("login.resend");
                this.isSend = false;
                clearInterval(this.timeId);
              }
            }, 1000);
          }
        })
        .catch((e) => {
          console.log("sendCode", e);
          this.$message.error(e);
        });
    },

    beforeLoginOfPwd() {
      let phone = this.formCode.phone.replace(/\s+/g, "");

      if (!phone) {
        this.textErr = this.$t("login.phone-number-does-not-have-value");
        return;
      }
      if (phone.length !== 11 && LOCALE == "zh-CN") {
        this.textErr = this.$t("login.please-enter-a-valid-phone-number");
        return;
      }
      if (!/^1[3456789]\d{9}$/.test(phone) && LOCALE == "zh-CN") {
        this.textErr = this.$t("login.please-enter-a-valid-phone-number");
        return;
      }

      if (this.loginType === 2) {
        if (!this.formCode.code) {
          this.textErr = this.$t("login.verification-code-must-be-filled");
          return;
        }

        // 验证码登录
        this.loginSubmit();
      } else if (this.loginType === 1) {
        if (!this.formCode.passwd) {
          this.textErr = this.$t("login.password-does-not-have-value");
          return;
        }
        if (this.formCode.passwd.length < 6) {
          this.textErr = this.$t("login.password-length-must-be-at-least-6-characters");
          return;
        }
        if (!/[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/.test(this.formCode.passwd)) {
          this.textErr = this.$t("login.your-password-must-contain-letters-and-numbers");
          return;
        }

        this.showSlideVerify = true;
      }
    },

    loginSubmit() {
      let phone = this.formCode.phone.replace(/\s+/g, "");

      this.textErr = "";
      this.isConfirm = false;
      this.loading = true;

      post({
        url: "/api/user/login",
        data: {
          account: phone,
          pwd: this.loginType === 2 ? this.formCode.code : this.formCode.passwd,
          platform: 0,
          login_type: this.loginType,
          source_id: 10001,
          website: window.location.hostname,
        },
      })
        .then(({ data }) => {
          this.loading = false;
          if (data.status === 0) {
            // 切号前清掉旧 TIM sig，防止游客/上一账号缓存串号
            clearTimUserSigCache();
            localStorage.setItem("userInfo", JSON.stringify(data.data));
            localStorage.setItem("token", data.data.token);
            localStorage.setItem("id", data.data.id);
            this.getUserInfo();
            // 登录成功时清空聊天缓存
            this.clearChatList();
            location.reload();
          }
          if (data.status === 301) {
            console.log("zhuce");
            this.mobile_hash = data.data.mobile_hash;
            this.register();
          }
        })
        .catch((err) => {
          this.textErr = err.message;
          this.isConfirm = true;
          this.loading = false;
        });
    },
    channels() {
      return getChannel();
    },
    register() {
      let phone = this.formCode.phone.replace(/\s+/g, "");

      // 忘记密码
      post({
        url: "/webapi/user/register",
        data: {
          account: phone,
          mobile_hash: this.mobile_hash,
          platform: 0,
          pwd: "",
          sex: 0,
          device_info: localStorage.getItem("device_no"),
          // reg_source_id: "10001",
          reg_source_id: IS_njbnrkeji ? "UD70IUQQ" : this.channels(),
          website: window.location.host,
          anchor_id: /^\/liveMatchesTwo\/\d+/.test(this.$route.path) ? Number(this.$route.params.id) : 0,
        },
      })
        .then(({ data }) => {
          if (data.status === 0) {
            this.$message({
              message: this.$t("login.registration-success"),
              type: "success",
              customClass: "message-override",
            });
            clearTimUserSigCache();
            localStorage.setItem("userInfo", JSON.stringify(data.data));
            localStorage.setItem("token", data.data.token);
            localStorage.setItem("id", data.data.id);
            this.getUserInfo();
            // 注册成功时清空聊天缓存
            this.clearChatList();
            location.reload();
          }
        })
        .catch((err) => {
          this.textErr = err.message || "注册失败，请稍后再试";
        });
    },

    toForgetPasswordStep2() {
      let phone = this.formCode.phone.replace(/\s+/g, "");
      if (!phone) {
        this.textErr = this.$t("login.phone-number-does-not-have-value");
        return;
      }
      if (phone.length !== 11 && LOCALE == "zh-CN") {
        this.textErr = this.$t("login.please-enter-a-valid-phone-number");
        return;
      }
      if (!/^1[3456789]\d{9}$/.test(phone) && LOCALE == "zh-CN") {
        this.textErr = this.$t("login.please-enter-a-valid-phone-number");
        return;
      }
      if (!this.formCode.code) {
        this.textErr = this.$t("login.verification-code-must-be-filled");
        return;
      }
      this.textErr = "";

      post({
        url: "/api/user/readyForTakeOff",
        data: {
          mobile: phone,
          smscode: this.formCode.code,
        },
      })
        .then(({ data }) => {
          if (data.status === 0) {
            this.step = 2;
            this.mobile_hash = data.data.data.mobile_hash;
            this.passwordInputType = true;
            this.passwordInputType1 = true;
            this.passwordInputType2 = true;
          }
        })
        .catch((err) => {
          this.textErr = err.message;
        });
    },

    changePassword() {
      let phone = this.formCode.phone.replace(/\s+/g, "");
      if (!this.formCode.passwd1) {
        this.textErr = this.$t("login.password-does-not-have-value");
        return;
      }
      if (this.formCode.passwd1.length < 6) {
        this.textErr = this.$t("login.password-length-must-be-at-least-6-characters");
        return;
      }
      if (this.formCode.passwd1.length > 12) {
        this.textErr = this.$t("login.password-length-must-be-up-to-12-characters");
        return;
      }
      if (!/[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/.test(this.formCode.passwd1)) {
        this.textErr = this.$t("login.your-password-must-contain-letters-and-numbers");
        return;
      }
      if (this.formCode.passwd1 !== this.formCode.passwd2) {
        this.textErr = this.$t("login.the-two-password-inputs-are-inconsistent");
        return;
      }

      this.textErr = "";
      this.loading = true;

      post({
        url: "/api/user/forgetPwdHash",
        data: {
          mobile: phone,
          mobile_hash: this.mobile_hash,
          pwd: this.formCode.passwd1,
        },
      })
        .then(({ data }) => {
          this.loading = false;
          if (data.status === 0) {
            // this.formCode = {
            //   phone: "",
            //   code: "",
            //   passwd: "",
            //   passwd1: "",
            //   passwd2: "",
            // };
            this.step = 3;
            setTimeout(() => {
              this.$message({
                message: data.data.msg,
                type: "success",
              });
            }, 1000);
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
  },

  created() {
    this.open_eyes = require("./img/psw-show.png");
    this.close_eyes = require("./img/psw-hide.png");
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  background: transparent;
  border-radius: 0.16rem;
  box-shadow: 0 0px 0px rgba(0, 0, 0, 0.3);
}

::v-deep .el-dialog__header {
  padding: 0;
}

::v-deep .el-dialog__body {
  padding: 0;
}

::v-deep .el-input__inner {
  background: #f1f3f6;
  border: none;
  padding: 0;
}

::v-deep .el-message {
  z-index: 3000;
}

.slide-verify-pos {
  position: absolute;
  max-width: 670px;
  top: 122px;
  right: 12px;
  //left: 86.2%;
  //transform: translate3d(-50%, 0.1rem, 0.1rem);
  background-color: #fff;
}

.slide-verify-pos-right {
  right: 183px;
}

.login-wrap {
  .activeHeader {
    background: url("./img/login-bg21.png") no-repeat !important;
    background-size: 100% 100% !important;
  }

  .header {
    //opacity: 0;
    width: 900px;
    height: 490px;
    background: url("./img/login-bg22.png") no-repeat;
    background-color: transparent;
    background-size: 100% 100%;
    border-radius: 0.16rem;
    border-radius: 0.16rem 0.16rem 0 0;
    position: relative;
    display: flex;

    .close {
      width: 22px;
      height: 22px;

      position: absolute;
      top: 40px;
      right: 20px;
      cursor: pointer;
    }

    .header-logo {
      //width: 406px;
      height: 430px;
      margin: 1.02rem auto 0;
    }

    .contenHeader {
      width: 544px;
      height: 128px;
    }

    .content1 {
      background-color: #ffffff;
      display: flex;
      width: 533.3px;
      height: 345px;
      margin-right: 13px;
      border-radius: 0.2rem;
      align-items: center;
      justify-content: center;
    }

    .content {
      // width: 540px;
      .notice {
        padding: 0.05rem 0;
        background: rgba(255, 186, 57, 0.1);
        border-radius: 0.1rem;
        color: #ffba39;
        font-size: 0.13rem;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 0.1rem;
      }

      .input1 {
        width: 427px;
        border-radius: 0.16rem;
        display: flex;
        height: 45px;
        background: #f1f3f6;
        align-items: center;
        border-bottom: 0.01rem solid #f0f0f0;
        margin-bottom: 0.1rem;
        overflow: hidden;

        .a {
          color: #666666;
          margin-left: 18px;
        }

        .b {
          width: 18px;
          height: 18px;
          margin-left: 10px;
          margin-right: 10px;
          background-image: url("./img/un.png");
          background-size: 100% 100%;
          //background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0));
        }

        img {
          width: 20px;
          height: 20px;
        }

        .password {
          cursor: pointer;
          margin-right: 5px;
        }

        .send_class {
          font-size: 0.15rem;
          color: var(--theme-primary);
          //margin-top: 0.13rem;
          line-height: 43px;
          cursor: pointer;
        }

        .last_down_time {
          font-size: 0.15rem;
          color: #ff4014;
          //margin-top: 0.08rem;
          line-height: 43px;
        }
      }

      .message {
        height: 30px;
        display: flex;
        border-radius: 0.1rem;
        background: #ffe4ad;
        align-items: center;
        color: #734f07;
        font-size: 0.12rem;

        img {
          width: 15px;
          height: 15px;
          margin: 0 5px;
        }

        .forget {
          cursor: pointer;
        }
      }

      //.btn {
      //  height: 0.48rem;
      //  display: flex;
      //  align-items: center;
      //  justify-content: center;
      //  font-size: 0.16rem;
      //  color: #fff;
      //  margin-top: 0.4rem;
      //  margin-bottom: 16px;
      //  background: linear-gradient(108.02deg, #e2e4e4 0%, #d3d6da 62.15%);
      //  border-radius: 0.06rem;
      //}
      .btn-confirm {
        height: 48px;
        width: 100%;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.16rem;
        cursor: pointer;
        color: #ffffff;
        margin-top: 32px;
        margin-bottom: 14px;
        background: linear-gradient(90deg, rgba(255, 107, 138, 0.5), rgba(255, 138, 107, 0.5));
        border-radius: 0.5rem;

        &.active {
          background: linear-gradient(90deg, #FF6B8A, #FF8A6B);
          box-shadow: 0px 4px 8px 0px rgba(255, 107, 138, 0.3);
        }
      }

      .pass-login {
        font-size: 0.16rem;
        color: #FF6B8A;
        margin-top: 20px;
        text-align: center;
        cursor: pointer;
      }
    }
  }

  .header-forget {
    background: url("./img/back-pass.png") no-repeat;
    background-size: 100% 100%;
    flex-direction: column;
    width: 540px;
    height: 544px;

    .text {
      margin: 0.4rem auto 0;
      font-weight: 800;
      font-size: 30px;
      color: var(--theme-primary);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .step {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 30px;
      img{
        width: 30px;
        height: 30px;
      }

      .round {
        width: 30px;
        height: 30px;
        border-radius: 0.21rem;
        background: linear-gradient(108.02deg, #e2e4e4 0%, #d3d6da 62.15%);
        box-shadow: 0px 0px 3.83px 0px #8d92a6 inset;
        border: 0.02rem solid #eeeeee;
        background-clip: content-box;
        color: #fff;
        font-size: 18px;
        font-weight: 500;
        text-align: center;
        line-height: 26px;
      }

      .bar {
        width: 90px;
        height: 0.02rem;
        opacity: 0.5;
        background: #8d92a6;
        margin: 0 20px;
      }

      .round-active {
        // background: var(--theme-primary);
        background: linear-gradient(180deg, #4cceff 0%, #003aff 100%);
        box-shadow: 0px 0px 3.83px 0px var(--theme-primary) inset;

        border: 2px solid rgba(2, 168, 162, 0.2);
        background-clip: content-box;
      }

      .bar-active {
        background: linear-gradient(180deg, #4cceff 0%, #003aff 100%);
        // background: var(--theme-gradient);
      }
    }

    .desc {
      display: flex;
      justify-content: space-around;
      margin: 15px 35px;
      font-size: 0.18rem;
    }
  }

  .content-pss {
    display: flex;
    width: 540px;
    margin-top: 30px;
    margin-right: 13px;
    //border-radius: 0.2rem;
    align-items: center;
    justify-content: center;
    // width: 540px;

    .notice {
      padding: 0.05rem 0;
      background: rgba(255, 186, 57, 0.1);
      border-radius: 0.1rem;
      color: #ffba39;
      font-size: 0.13rem;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 0.1rem;
    }

    .input1 {
      width: 427px;
      border-radius: 0.16rem;
      display: flex;
      height: 45px;
      background: #ffffff;
      align-items: center;
      border-bottom: 0.01rem solid #f0f0f0;
      margin-bottom: 0.1rem;
      overflow: hidden;

      .a {
        color: #666666;
        margin-left: 18px;
      }

      .b {
        width: 18px;
        height: 18px;
        margin-left: 10px;
        margin-right: 10px;
        background-image: url("./img/un.png");
        background-size: 100% 100%;
        //background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0));
      }

      ::v-deep .el-input__inner {
        background: #ffffff;
        border: none;
        padding: 0;
      }

      img {
        width: 20px;
        height: 20px;
      }

      .password {
        cursor: pointer;
        margin-right: 5px;
      }

      .send_class {
        font-size: 0.15rem;
        color: var(--theme-primary);
        //margin-top: 0.13rem;
        line-height: 43px;
        cursor: pointer;
      }

      .last_down_time {
        font-size: 0.15rem;
        color: #ff4014;
        //margin-top: 0.08rem;
        line-height: 43px;
      }
    }

    .message {
      height: 30px;
      display: flex;
      border-radius: 0.1rem;
      background: #ffe4ad;
      align-items: center;
      color: #734f07;
      font-size: 0.12rem;

      img {
        width: 15px;
        height: 15px;
        margin: 0 5px;
      }

      .forget {
        cursor: pointer;
      }
    }

    //.btn {
    //  height: 0.48rem;
    //  display: flex;
    //  align-items: center;
    //  justify-content: center;
    //  font-size: 0.16rem;
    //  color: #fff;
    //  margin-top: 0.4rem;
    //  margin-bottom: 16px;
    //  background: linear-gradient(108.02deg, #e2e4e4 0%, #d3d6da 62.15%);
    //  border-radius: 0.06rem;
    //}
    .btn-confirm {
      height: 48px;
      width: 100%;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.16rem;
      cursor: pointer;
      color: #ffffff;
      margin-top: 25px;
      margin-bottom: 14px;
      background: linear-gradient(90deg, rgba(255, 107, 138, 0.5), rgba(255, 138, 107, 0.5));
      border-radius: 0.5rem;

      &.active {
        background: linear-gradient(90deg, #FF6B8A, #FF8A6B);
        box-shadow: 0px 4px 8px 0px rgba(255, 107, 138, 0.3);
      }
    }

    .pass-login {
      font-size: 0.16rem;
      color: #FF6B8A;
      margin-top: 10px;
      text-align: center;
      cursor: pointer;
    }
  }
}
</style>
